export enum VideoDetailsMode {
  VideoPlayer = 'VideoPlayer',
  SideBySidePlayer = 'SideBySidePlayer',
  AiFrames = 'AiFrames',
  Tags = 'Tags',
}
